module.exports = __webpack_public_path__ + "img/EA130_1-1.003c6d8f.jpg";